import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bdb-backdrop',
  templateUrl: './bdb-backdrop.component.html',
  styleUrls: ['./bdb-backdrop.component.scss']
})
export class BdbBackdropComponent {
  @Output() backDropClosed = new EventEmitter<boolean>();

  @Input() idEl = 'bdb-at-backdrop';

  @Input() isOpen = false;

  @Input() tabClose = false;

  @Input() overScroll = false;

  @Input() alignItems = 'center';

  @Input() animated = true;

  @Input() backgroundColor = 'rgba(0, 25, 71, 0.8)';

  class = 'bdb-at-backdrop animated';

  constructor() { }

  ngOnChanges() {
    this.changeClass();
  }

  changeClass(): void {
    this.class = `bdb-at-backdrop animated ${this.isOpen ? 'bdb-at-backdrop--show' : ''}`;
  }

  async openBackdrop(): Promise<void> {
    this.isOpen = true;
    document.querySelector(`#${this.idEl}`).classList.remove('fadeOut');
    if (this.animated) {
      document.querySelector(`#content-slot`).classList.remove('fadeOutDownBig');
      document.querySelector(`#content-slot`).classList.add('fadeInUpBig');
    }
    if (this.overScroll) {
      const body = document.querySelector('body');
      body.style.overflow = 'hidden';
    }
    this.changeClass();
  }

  async closeBackdrop(): Promise<void> {
    this.isOpen = false;
    document.querySelector(`#${this.idEl}`).classList.add('fadeOut');
    if (this.animated) {
      document.querySelector(`#content-slot`).classList.remove('fadeInUpBig');
      document.querySelector(`#content-slot`).classList.add('fadeOutDownBig');
    }
    if (this.overScroll) {
      const body = document.querySelector('body');
      body.style.overflow = 'auto';
    }
    setTimeout(() => {
      document.querySelector(`#${this.idEl}`).classList.remove('fadeOut');
    }, 200);
    this.changeClass();
  }

  tabBackdrop(e): void {
    const close = document.querySelector('#content-slot').contains(e.target);
    if (this.tabClose && close) {
      this.closeBackdrop();
      this.backDropClosed.emit(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/webcomponents/bdb-backdrop/bdb-backdrop.component.ts